import pluralize from 'pluralize';
import { combineReducers } from 'redux';

const setup = action => {
  // setup plural & singular RESOURCE_SINGLE name
  const RESOURCE = action.type.split('_')[1];
  const CUSTOM_ACTION = action.type.split('_')[2];
  const RESOURCE_SINGLE = RESOURCE ? pluralize.singular(RESOURCE) : '';
  const IS_SINGLE_RESOURCE = RESOURCE === RESOURCE_SINGLE;
  const IS_ADDITIONAL_RESOURCES = action.additional_resources;

  return {
    RESOURCE,
    CUSTOM_ACTION,
    RESOURCE_SINGLE,
    IS_SINGLE_RESOURCE,
    IS_ADDITIONAL_RESOURCES,
  };
};

export const customActionReducer = (state = {}, action) => {
  const {
    RESOURCE,
    RESOURCE_SINGLE,
    IS_SINGLE_RESOURCE,
    CUSTOM_ACTION,
    IS_ADDITIONAL_RESOURCES,
  } = setup(action);

  if (!IS_ADDITIONAL_RESOURCES) {
    return state;
  }

  switch (action.type) {
    case `GET_${RESOURCE}_SUCCESS`:
      if (!IS_SINGLE_RESOURCE && !action.alias)
        return { ...state, [`${RESOURCE}`]: [...action.data] };
      if (!IS_SINGLE_RESOURCE && action.alias)
        return { ...state, [`${RESOURCE}_${action.alias}`]: [...action.data] };
      return state;
    case `GET_${RESOURCE}_${CUSTOM_ACTION}_SUCCESS`:
      // only apply reducer if action is not initiated by single resource
      // store data in action alias namespace if alias supplied
      // example usage, we may call getRoleContentsByRoleId twice, first time with role id
      // and 2nd call without role id to return contents for
      // role contents and all available contents respectively
      if (!IS_SINGLE_RESOURCE)
        return {
          ...state,
          [`${RESOURCE}_${action.alias || CUSTOM_ACTION}`]: [...action.data]
            .length
            ? [...action.data]
            : { ...action.data },
        };
      return state;
    default:
      // bounce back to combineReducers function
      return state;
  }
};

export const loadingReducer = (state = [], action) => {
  const { RESOURCE, IS_SINGLE_RESOURCE, IS_ADDITIONAL_RESOURCES } = setup(
    action
  );

  // only apply the resource reducer on main resource
  if (IS_ADDITIONAL_RESOURCES) {
    return state;
  }

  switch (action.type) {
    // case `GET_${RESOURCE}`:
    //   if (!IS_SINGLE_RESOURCE) return { loading: 'true' };
    //   return state;
    case `GET_${RESOURCE}`:
      // only apply reducer if action is not initiated by single resource
      if (!IS_SINGLE_RESOURCE) return true;
      return state;
    case `GET_${RESOURCE}_SUCCESS`:
      // only apply reducer if action is not initiated by single resource
      if (!IS_SINGLE_RESOURCE) return false;
      return state;
    default:
      // bounce back to combineReducers function
      return state;
  }
};

export const resourceReducer = (state = [], action) => {
  const {
    RESOURCE,
    RESOURCE_SINGLE,
    IS_SINGLE_RESOURCE,
    IS_ADDITIONAL_RESOURCES,
  } = setup(action);

  // only apply the resource reducer on main resource
  if (IS_ADDITIONAL_RESOURCES) {
    return state;
  }

  switch (action.type) {
    // case `GET_${RESOURCE}`:
    //   if (!IS_SINGLE_RESOURCE) return { loading: 'true' };
    //   return state;
    case `GET_${RESOURCE}_SUCCESS`:
      // only apply reducer if action is not initiated by single resource
      if (!IS_SINGLE_RESOURCE) return [...action.data];
      return state;
    case `DELETE_${RESOURCE_SINGLE}_SUCCESS`:
      return [...state.filter(data => data.id !== action.id)];
    case `CREATE_${RESOURCE_SINGLE}_SUCCESS`:
      return [...state, action.data];
    case `UPDATE_${RESOURCE_SINGLE}_SUCCESS`:
      return [
        ...state.map(data => {
          if (data.id !== action.id) return data;
          return action.data;
        }),
      ];
    default:
      // bounce back to combineReducers function
      return state;
  }
};

export const singleReouceReducer = (state = {}, action) => {
  const { RESOURCE_SINGLE } = setup(action);

  switch (action.type) {
    case `SELECT_${RESOURCE_SINGLE}`:
      // change the reducer field name to singular if we only
      // allow select one RESOURCE_SINGLE at a time
      return { ...action.data };
    case `GET_${RESOURCE_SINGLE}`:
      return {};
    case `GET_${RESOURCE_SINGLE}_SUCCESS`:
      const data = Array.isArray(action.data)?action.data[0]: action.data;
      return { ...data };
    case `ADD_${RESOURCE_SINGLE}`:
      return {};
    case `CREATE_${RESOURCE_SINGLE}_SUCCESS`:
      return { ...action.data };
    case `CHANGE_${RESOURCE_SINGLE}`:
      return { ...state, [action.field]: action.data };
    case `DELETE_${RESOURCE_SINGLE}_SUCCESS`:
      return {};
    default:
      // bounce back to combineReducers function
      return state;
  }
};

const ReducerFactory = combineReducers({
  records: resourceReducer,
  selected_record: singleReouceReducer,
  additional_resources: customActionReducer,
  loading_records: loadingReducer,
});

export default ReducerFactory;



// WEBPACK FOOTER //
// ./src/reducer/ReducerFactory.js